import React from 'react';

import { TemplateStyledButton } from 'screens/admin/Reviews/ReviewTemplate/common/styles';
import styled from 'styled-components';
import { StyledBox } from 'styles/common';

import { getColorFromKey } from 'constants/helper';

const FooterActions = ({ actions, leftComponent }) => (
  <StyledContainer>
    <StyledBox>{leftComponent || null}</StyledBox>
    <StyledBox>
      {actions &&
        actions.map((action, idx) => (
          <CustomStyledButton
            key={idx}
            customColor={action.color}
            borderColor={action.borderColor}
            fontColor={action.fontColor}
            onClick={() => action.onClick && action.onClick()}
            rightGutter={idx === actions.length - 1 ? 0 : 4}
            startIcon={action.icon}
            disabled={action.disabled || false}
          >
            {action.text}
          </CustomStyledButton>
        ))}
    </StyledBox>
  </StyledContainer>
);

export default FooterActions;

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 1.5rem 4rem;
  border: 2px solid ${getColorFromKey('lightGrey')};
  border-radius: 5px;
  max-height: 72px;
`;

const CustomStyledButton = styled(TemplateStyledButton)`
  min-width: 20ch;
`;
